<template>
  <v-card :elevation="3">
    <v-card-title>
      <v-icon class="mr-2">mdi-cart</v-icon>
      Carrinho
      <v-spacer></v-spacer>
      <v-chip
        v-if="items.length > 0"
        small
        outlined
      >
        {{ items.length }} {{ items.length === 1 ? 'item' : 'itens' }}
      </v-chip>
    </v-card-title>

    <div v-if="$vuetify.breakpoint.xsOnly" class="mobile-cart-list">
      <div v-if="items.length === 0" class="mobile-cart-empty">Carrinho Vazio</div>
      <div
        v-for="item in items"
        :key="item.product_id"
        class="mobile-cart-item"
      >
        <div class="mobile-cart-info">
          <span class="mobile-cart-desc">{{ item.description }}</span>
          <span class="mobile-cart-detail">
            <strong>{{ item.amount }}x</strong>
            {{ formatPrice(item.value_sale) }}
            =
            <strong>{{ formatPrice(item.value_subtotal_product) }}</strong>
            <span v-if="parseFloat(item.value_descont_product) > 0" class="red--text ml-1">
              -{{ formatPrice(item.value_descont_product) }}
            </span>
          </span>
        </div>
        <div class="mobile-cart-actions">
          <v-icon small color="orange darken-3" @click="descontItemCar(item)">mdi-calculator</v-icon>
          <v-icon small color="orange darken-3" @click="editItemCar(item)">mdi-pencil</v-icon>
          <v-icon small color="red darken-3" @click="deleteItem(item)">mdi-delete</v-icon>
        </div>
      </div>
    </div>

    <v-data-table
      v-else
      dense
      :headers="headers"
      :items="items"
      fixed-header
      :items-per-page="-1"
      height="50vh"
      hide-default-footer
      no-data-text="Carrinho Vazio"
    >
      <template v-slot:item.description="{ item }">
        {{ item.description }}
      </template>

      <template v-slot:item.amount="{ item }">
        <strong>{{ item.amount }}x</strong>
      </template>

      <template v-slot:item.value_sale="{ item }">
        {{ formatPrice(item.value_sale) }}
      </template>

      <template v-slot:item.value_descont_product="{ item }">
        <span v-if="parseFloat(item.value_descont_product) > 0">
          {{ formatPrice(item.value_descont_product) }}
        </span>
        <span v-else class="grey--text">-</span>
      </template>

      <template v-slot:item.value_subtotal_product="{ item }">
        <strong>{{ formatPrice(item.value_subtotal_product) }}</strong>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon small color="orange darken-3" v-on="on" @click="descontItemCar(item)">mdi-calculator</v-icon>
          </template>
          <span>Aplicar desconto</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon small color="orange darken-3" class="ml-2" v-on="on" @click="editItemCar(item)">mdi-pencil</v-icon>
          </template>
          <span>Editar quantidade</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon small color="red darken-3" class="ml-2" v-on="on" @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
          <span>Remover item</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-divider></v-divider>
    <v-divider></v-divider>
    <v-card-actions class="card-actions-container">
      <div class="footerTable">
        <!-- Total da Compra -->
        <div class="payment-section">
          <p class="payment">
            <span class="paymentTotal">Total a Pagar</span>: 
            <span class="numberTotal">R$ {{ totalWithLoyaltyDiscount.toFixed(2) }}</span>
          </p>
          <div v-if="loyaltyDiscount > 0" class="discount-details">
            <small class="discount-breakdown">
              Subtotal: R$ {{ total.toFixed(2) }} | Desconto fidelidade: -R$ {{ loyaltyDiscount.toFixed(2) }}
            </small>
          </div>
        </div>

        <!-- Informações de Cliente e Vendedor -->
        <div class="info-section">
          <div class="info-row">         
            <span class="info-label">Cliente:</span> 
            <span class="info-value">{{this.component.client.name}}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Vendedor:</span> 
            <span class="info-value">{{this.component.seller.name}}</span>
          </div>
          <div class="info-row">         
            <span class="info-label">Operador:</span> 
            <span class="info-value">{{user.name}}</span>
          </div>
          <div class="info-row">
            <span class="info-label">PDV:</span> 
            <span class="info-value">{{pdvId}}</span>
          </div>
        </div>

      </div>
      
      <v-spacer class="mobile-hidden"></v-spacer>
      <div class="actions-buttons">
        <CustomButtom />
        
        <!-- Botão de Fidelidade -->
        <v-btn
          v-if="hasLoyaltyPoints"
          class="purple darken-2 white--text action-btn"
          @click="toggleLoyaltyPanel"
          :disabled="items.length === 0"
        >
          <v-icon left>mdi-diamond</v-icon>
          Pontos ({{ displayLoyaltyPoints }})
        </v-btn>
        
        <v-btn
          class="red darken-4 white--text action-btn"
          @click="() => { ClearCart(); }"
        >
          <v-icon left>mdi-cart-remove</v-icon>Limpar
        </v-btn>
        <v-btn
          class="green darken-4 white--text action-btn"
          @click="() => { FinishSaleFormOfPaymentsEndCondidtionsPayments(); }"
          :disabled="valid"
        >
          <v-icon left>mdi-cart-arrow-right</v-icon>PAGAR
        </v-btn>
      </div>
    </v-card-actions>
    
    <!-- Painel de Fidelidade Flutuante -->
    <div v-if="showLoyaltyPanel && hasLoyaltyPoints" class="loyalty-popup">
      <div class="loyalty-popup-content">
        <div class="loyalty-popup-header">
          <span class="loyalty-popup-title">💎 {{displayLoyaltyPoints}} pts</span>
          <v-btn
            small
            icon
            color="primary"
            @click="openLoyaltyLedger"
            class="ml-2"
            title="Ver extrato de pontos"
          >
            <v-icon small>mdi-file-document-outline</v-icon>
          </v-btn>
        </div>
        <div class="loyalty-popup-controls">
          <v-text-field
            v-model="pointsToUse"
            label="Usar pontos"
            type="number"
            :max="clientLoyaltyPoints"
            min="0"
            dense
            outlined
            hide-details
            class="loyalty-input"
            @input="calculateLoyaltyDiscount"
          ></v-text-field>
          <div class="loyalty-popup-discount">
            -R$ {{loyaltyDiscount.toFixed(2)}}
          </div>
        </div>
      </div>
    </div>
    
    <EditProduct :component="this" />
    <DescontProduct :component="this" />
    <DeleteProduct :component="this" />
    <ClearCar :component="this" />
    <FinishSale v-if="dialog_finish" :component="this" />
    <AlertError
      v-if="dialog_alert"
      :title_error="errorTitle"
      :listErrors="errorsList"
      :component="this"
    />
    <PasswordDialog v-if="permissionDiscountDialog" :component="this" />
    
    <v-dialog v-model="showLoyaltyModal" persistent :max-width="$vuetify.breakpoint.xsOnly ? '95%' : '500px'">
      <v-card>
        <v-card-title class="headline">
          <v-icon class="mr-2 primary--text">mdi-star-circle</v-icon>
          Programa de Fidelidade
        </v-card-title>
        <v-card-text>
          <div class="text-center mb-4">
            <v-icon :size="$vuetify.breakpoint.xsOnly ? 48 : 64" color="primary">mdi-gift</v-icon>
          </div>
          <p :class="['text-center', 'mb-3', $vuetify.breakpoint.xsOnly ? 'text-subtitle-1' : 'text-h6']">
            Deseja participar do nosso programa de fidelidade?
          </p>
          <p class="text-center">
            Acumule pontos a cada compra e ganhe vantagens exclusivas!
          </p>
        </v-card-text>
        <v-card-actions :class="$vuetify.breakpoint.xsOnly ? 'd-flex flex-column-reverse pb-4 px-4' : 'justify-center pb-4'">
          <v-btn
            color="grey"
            text
            @click="skipLoyaltyProgram"
            :block="$vuetify.breakpoint.xsOnly"
            :class="$vuetify.breakpoint.xsOnly ? 'mt-2' : 'mr-4'"
          >
            Não, obrigado
          </v-btn>
          <v-btn
            color="primary"
            @click="joinLoyaltyProgram"
            elevation="2"
            :block="$vuetify.breakpoint.xsOnly"
          >
            <v-icon left>mdi-check</v-icon>
            Sim, quero participar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog do Extrato de Fidelidade -->
    <v-dialog v-model="showLoyaltyLedgerDialog" :max-width="$vuetify.breakpoint.xsOnly ? '95%' : '600px'">
      <v-card>
        <v-card-title class="pb-2">
          Extrato de Pontos
          <v-spacer></v-spacer>
          <v-btn icon @click="showLoyaltyLedgerDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0" :style="{ maxHeight: $vuetify.breakpoint.xsOnly ? '60vh' : '400px', overflowY: 'auto' }">
          <div v-if="isLoyaltyLoading" class="text-center pa-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <div v-else-if="loyaltyLedgerData && loyaltyLedgerData.length > 0">
            <v-list>
              <v-list-item
                v-for="movement in loyaltyLedgerData"
                :key="movement.id"
                class="px-4 py-3"
              >
                <v-list-item-avatar :color="movement.type_movement === 'A' ? 'green' : 'red'">
                  <v-icon dark>{{ movement.type_movement === 'A' ? 'mdi-plus' : 'mdi-minus' }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="d-flex align-center">
                    <span :class="movement.type_movement === 'A' ? 'green--text' : 'red--text'" class="font-weight-bold">
                      {{movement.type_movement === 'A' ? '+' : ''}}{{movement.points}} pts
                    </span>
                    <v-spacer></v-spacer>
                    <small class="grey--text">{{formatDate(movement.created_at)}}</small>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{movement.description}}
                  </v-list-item-subtitle>
                  <div v-if="movement.sale" class="mt-1">
                    <small class="text--secondary">
                      Venda #{{movement.sale.number_sale}} - R$ {{movement.sale.value_total_note}}
                    </small>
                  </div>
                </v-list-item-content>
                <v-list-item-action>
                  <small class="grey--text">Saldo: {{movement.points_after}}</small>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
          <div v-else class="text-center pa-4">
            <p class="grey--text">Nenhuma movimentação encontrada</p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import CustomButtom from "./component/buttom.vue";
import { headers } from "./script";
import EditProduct from "../AddDialog/Edit_Product";
import DescontProduct from "../AddDialog/Descont_Product";
import DeleteProduct from "../AddDialog/Delete_Product";
import ClearCar from "../AddDialog/Delete_All_Cart/";
import FinishSale from "../AddDialog/Finish_Sale/";
import AlertError from "../AddDialog/Modal_Error/";
import PasswordDialog from "./Password_Dialog/index.vue";
import { GET_CALC_TRIBUTE } from "../../../store/actions/sales";
import ENV from "../../../env"
import {
  DESTROY_CART,
  UPDATE_CART,
  CLEAN_CART,
  DISCOUNT_PERMISSION,
  SET_DISCOUNT_PERMISSION,
} from "../../../store/actions/cart";
import { GET_ALL_ENTERPRISE } from "../../../store/actions/enterprise";
import { GET_LOYALTY_LEDGER } from "../../../store/actions/loyalty";
import { mapGetters } from "vuex";

export default {

  
  components: {
    DescontProduct,
    EditProduct,
    DeleteProduct,
    ClearCar,
    FinishSale,
    AlertError,
    CustomButtom,
    PasswordDialog,
  },


  props: {
    component: Object,
    datas: Object,
    disabled: Boolean
  },

  data: () => ({
    pdvId: ENV.getInstance().VUE_APP_PDV_COMPUTER_ID,
    user: Object(),
    headers,
    dialog: false,
    dialog_delete: false,
    dialog_clear: false,
    dialog_finish: false,
    dialog_descont: false,
    dialog_alert: Boolean(),
    errorsList: Array(),
    errorTitle: String(),
    element: Object(),
    getEnterprise: Object(),
    items: Array(),
    valid: Boolean(),
    indexOf: Number(),
    amount: "",
    valueDescont: Number(),
    type_descont: "",
    total: 0,
    enterprise_id: Number(),
    permissionDiscountDialog: Boolean(),
    isLoading: false,
    email: String(),
    password: String(),
    totalDescount: Number(),
    showLoyaltyModal: false,
    showLoyaltyPanel: false,
    showLoyaltyLedgerDialog: false,
    pointsToUse: 0,
    loyaltyDiscount: 0,
    loyaltySettings: {},
    sale: {
      status: "Em Digitacao",
      number_doc_client: "",
      data_sale: new Date,
      access_key: String(),
      number_sale: String(),
      authorization_protocol: String(),
      series: String(),
      wasProcessed: false,

      value_total_products: Number(),
      value_total_note: Number(),
      value_descount_total: Number(),
      value_account_total: Number(),

      value_icms_substituicao_total: Number(),
      base_cal_icms_total: Number(), //alterado  back ok
      base_calc_susbt_total: Number(), //alterado back ok
      value_icms_free_total: Number(),
      value_outher_tax_total: Number(),
      value_icms_total: Number(),

      note: "Venda de mercadoria", // Valor Mocado

      value_ipi_total: Number(),
      value_ipi_outher_total: Number(),
      value_ipi_free_total: Number(),
      base_calc_ipi_total: Number(),
    
      value_base_pis_total: Number(),
      value_base_pis_st_total: Number(),
      value_other_pis_total: Number(),
      value_pis_st_total: Number(),
      value_pis_total: Number(),

      value_base_cofins_st_total: Number(),
      value_base_cofins_total: Number(),
      value_other_cofins_total: Number(),
      value_cofins_st_total: Number(),
      value_cofins_total: Number(),
      valueApproximateTax:Number(),
      
      value_base_tax_selective: Number(),
      value_tax_selective: Number(),
      value_total_tax_uf: Number(),
      value_total_tax_mun: Number(),
      value_total_ibs: Number(),
      value_total_cred_presumid: Number(),
      value_deferimento: Number(),
      value_total_returns: Number(),
      value_exemption: Number(),
      value_cbs_total: Number(),
      value_base_total_cbs_mono: Number(),
      value_total_cbs_mono: Number(),

      client_id: Number(),
      tax_operation_types_id: 2,
      enterprise_id: 1,
      account_plans_id: ENV.getInstance().VUE_APP_PDV_ACCOUNT_PLAN,
      pdv_id: ENV.getInstance().VUE_APP_PDV_COMPUTER_ID,
      seller_id: Number(),
      note_models_id: null,
      form_of_payments: Array(),
      itens_sales: Array(),
      enterprise: Object(),
      client: Object(),
      seller:Object(),
      user_id: 1
    }
  }),

  methods: {
    formatPrice(value) {
      if (value === null || value === undefined) {
        return 'R$ 0,00';
      }
      return parseFloat(value).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
    },

    async GetEnterprise() {
      await this.$store.dispatch(GET_ALL_ENTERPRISE, {
        page: 1, limit: 10, paginate:true
      });
    },
    editItemCar(item) {
      this.showLoyaltyPanel = false;
      this.dialog = !this.dialog;
      this.element = { ...item };
      // this.indexOf = this.getCart.indexOf(item);
      this.amount = this.element.amount;
    },
    onKey(e) {
      let KeyCode = e.key;
      switch (KeyCode) {
        case "F9":
          if (this.items.length > 0) {
       
            this.FinishSaleFormOfPaymentsEndCondidtionsPayments();
          } else {
            this.valid = true;
          }
          break;

        case "Escape":
          this.dialog_finish = false;

          break;
      }
    },
    async recalculetributeEditQuantidadeItem(item) {
     let productTribute =  await this.$store .dispatch(GET_CALC_TRIBUTE, {
          product: item,
          enterprise: this.getEnterprise
        })

          if (productTribute) {
            this.element.value_base_icms_product = productTribute.value_base_icms_product;
            this.element.value_accounting_product =
              productTribute.value_accounting_product;
            this.element.value_icms_product = productTribute.value_icms_product;
            this.element.aliquot_ipi_product =
              productTribute.aliquot_ipi_product;
            this.element.value_cofins_product =
              productTribute.value_cofins_product;
            this.element.aliquot_icms_product =
              productTribute.aliquot_icms_product;
            this.element.value_base_icms_st_product =
              productTribute.value_base_icms_st_product;
            this.element.value_icms_st_product =
              productTribute.value_icms_st_product;
            this.element.value_ipi_product = productTribute.value_ipi_product;
            this.element.value_free_cofins_product =
              productTribute.value_free_cofins_product;
            this.element.value_other_pis_product =
              productTribute.value_other_pis_product;
            this.element.value_pis_st_product =
              productTribute.value_pis_st_product;
            this.element.value_free_icms_product =
              productTribute.value_free_icms_product;
            this.element.value_icms_outher_product =
              productTribute.value_icms_outher_product;
            this.element.value_base_ipi_product =
              productTribute.value_base_ipi_product;
            this.element.aliquota_pis = productTribute.aliquota_pis;
            this.element.value_base_pis_product =
              productTribute.value_base_pis_product;
            this.element.value_pis_product = productTribute.value_pis_product;
            this.element.value_base_cofins_product =
              productTribute.value_base_cofins_product;
            this.element.value_base_pis_st_product =
              productTribute.value_base_pis_st_product;
            this.element.value_base_cofins_st_product =
              productTribute.value_base_cofins_st_product;
            this.element.value_cofins_st_product =
              productTribute.value_cofins_st_product;
            this.element.value_other_pis_st_product =
              productTribute.value_other_pis_st_product;
            this.element.value_other_cofins_product =
              productTribute.value_other_cofins_product;
            this.element.value_free_pis_product =
              productTribute.value_free_pis_product;
            this.element.aliquota_cofins = productTribute.aliquota_cofins;
            this.element.value_ipi_free_product =
              productTribute.value_ipi_free_product;
            this.element.value_ipi_outher_product =
              productTribute.value_ipi_outher_product;
            this.element.cfop_id = productTribute.cfop_id;
            this.element.cst_id = productTribute.cst_id;
            this.element.csosn_id = productTribute.csosn_id;
            this.element.cst_pis_id = productTribute.cst_pis_id;
            this.element.cst_cofins_id = productTribute.cst_cofins_id;

            // Novos campos IBS/CBS - aplicar apenas para empresas que não são MEI ou SIMPLES NACIONAL
            this.element.value_base_cbs_product = productTribute.value_base_cbs_product || 0;
            this.element.value_cbs_product = productTribute.value_cbs_product || 0;
            this.element.value_base_ibs_uf_product = productTribute.value_base_ibs_uf_product || 0;
            this.element.value_ibs_uf_product = productTribute.value_ibs_uf_product || 0;
            this.element.value_base_ibs_mun_product = productTribute.value_base_ibs_mun_product || 0;
            this.element.value_ibs_mun_product = productTribute.value_ibs_mun_product || 0;
            this.element.value_base_tax_selective_prod = productTribute.value_base_tax_selective_prod || 0;
            this.element.value_tax_selective_prod = productTribute.value_tax_selective_prod || 0;
            this.element.value_total_tax_uf_prod = productTribute.value_total_tax_uf_prod || 0;
            this.element.value_total_tax_mun_prod = productTribute.value_total_tax_mun_prod || 0;
            this.element.value_total_ibs_prod = productTribute.value_total_ibs_prod || 0;
            this.element.value_total_cred_presumid_prod = productTribute.value_total_cred_presumid_prod || 0;
            this.element.value_deferimento_prod = productTribute.value_deferimento_prod || 0;
            this.element.value_total_returns_prod = productTribute.value_total_returns_prod || 0;
            this.element.value_exemption_prod = productTribute.value_exemption_prod || 0;
            this.element.value_cbs_total_prod = productTribute.value_cbs_total_prod || 0;
            this.element.value_base_total_cbs_mono_prod = productTribute.value_base_total_cbs_mono_prod || 0;
            this.element.value_total_cbs_mono_prod = productTribute.value_total_cbs_mono_prod || 0;
          }
   
    },

    deleteItem(item) {
      this.showLoyaltyPanel = false;
      this.dialog_delete = !this.dialog_delete;
      this.element = item;
      this.indexOf = this.getCart.indexOf(item);
    },
    clearClientSeller() {
      this.component.clear();
    },
    descontItemCar(item) {
      this.showLoyaltyPanel = false;
      this.dialog_descont = !this.dialog_descont;
      this.element = { ...item };

      this.indexOf = this.getCart.indexOf(item);
    },
    ClearCart() {
      this.showLoyaltyPanel = false;
      this.dialog_clear = !this.dialog_clear;
    },

    FinishSaleFormOfPaymentsEndCondidtionsPayments() {
      let validClient = undefined
      let validSeller = undefined
      validClient = this.component.client.id;
      validSeller = this.component.seller.id;
      this.sale.client = this.component.clientNfceObject;
      this.sale.seller = this.component.sellerNfceObject;
      this.sale.enterprise = this.component.enterpriseNfceObject;
      if (validClient == undefined || validSeller == undefined) {
        this.dialog_alert = !this.dialog_alert;
        this.errorTitle = "Campos Obrigatórios";
        this.errorsList = [
          { text: "Campo de Cliente" },
          { text: "Campo de Vendedor" }
        ];
      } else {
        this.sale.client_id = validClient;
        this.sale.seller_id = validSeller;

        if (this.loyaltyDiscount > 0) {
          this.sale.loyalty_discount = this.loyaltyDiscount;
          this.sale.loyalty_points_used = parseInt(this.pointsToUse);
        }

        this.showLoyaltyPanel = false;

        this.checkLoyaltyProgram();

        this.dialog_finish = !this.dialog_finish;
      }
    },

    checkLoyaltyProgram() {
      const clientData = this.component.clientNfceObject;
      const hasLoyalties = clientData && clientData.loyalties && clientData.loyalties.length > 0;
      if (!hasLoyalties) {
        this.showLoyaltyModal = true;
      }
    },

    joinLoyaltyProgram() {
      this.sale.want_by_loyalty = true;
      this.showLoyaltyModal = false;
    },

    skipLoyaltyProgram() {
      this.sale.want_by_loyalty = false;
      this.showLoyaltyModal = false;
    },

    toggleLoyaltyPanel() {
      this.showLoyaltyPanel = !this.showLoyaltyPanel;
    },

    handleClickOutside(event) {
      const loyaltyPanel = this.$el.querySelector('.loyalty-panel');
      const loyaltyButton = this.$el.querySelector('.purple.darken-2');
      
      if (this.showLoyaltyPanel && loyaltyPanel && loyaltyButton) {
        if (!loyaltyPanel.contains(event.target) && !loyaltyButton.contains(event.target)) {
          this.showLoyaltyPanel = false;
        }
      }
    },

    async loadLoyaltySettings() {
      try {
        const enterpriseId = this.getEnterprises.data[0].id;
        const settings = await this.$store.dispatch('GET_LOYALTY_SETTINGS', enterpriseId);
        this.loyaltySettings = settings;
      } catch (error) {
        console.error('Erro ao carregar configurações de fidelidade:', error);
      }
    },

    calculateLoyaltyDiscount() {
      if (!this.pointsToUse || !this.loyaltySettings.money_per_point) {
        this.loyaltyDiscount = 0;
        return;
      }

      const pointsToUseNum = parseInt(this.pointsToUse) || 0;
      const availablePoints = this.clientLoyaltyPoints;

      if (pointsToUseNum > availablePoints) {
        this.pointsToUse = availablePoints;
        return;
      }

      const moneyPerPoint = parseFloat(this.loyaltySettings.money_per_point);
      this.loyaltyDiscount = pointsToUseNum * moneyPerPoint;

      if (this.loyaltyDiscount > this.total) {
        const maxPoints = Math.floor(this.total / moneyPerPoint);
        this.pointsToUse = maxPoints;
        this.loyaltyDiscount = maxPoints * moneyPerPoint;
      }
    },

    async openLoyaltyLedger() {
      try {
        this.showLoyaltyPanel = false; 
        this.showLoyaltyLedgerDialog = true;
        const clientData = this.component.clientNfceObject;

        if (clientData && clientData.id) {
          await this.$store.dispatch(GET_LOYALTY_LEDGER, {
            client_id: clientData.id,
            enterprise_id: this.getEnterprises.data[0].id,
            page: 1,
            limit: 20
          });
        }
      } catch (error) {
        console.error('Erro ao carregar extrato de fidelidade:', error);
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    calculate(items) {
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      let item = items || [...this.items];
      this.items = [];
      let variable = item.map(e => e.value_subtotal_product);
      this.total = variable.reduce(reducer, 0);
      this.items = [...this.$store.getters.getCart];
      
      if (this.pointsToUse > 0) {
        this.calculateLoyaltyDiscount();
      }
    },

    confirm_clean_car() {
      this.$store.dispatch(CLEAN_CART);
      this.calculate(this.$store.getters.getCart);
    },
    permissionDiscountLogin() {
      this.isLoading = true
      const payload = {
        email: this.email,
        password: this.password,
        discount: this.totalDescount,
        enterprise_id: 1,
      }
      this.$store.dispatch(DISCOUNT_PERMISSION, payload)
    },
    giveDiscount() {
      if(this.type_descont == "PERCENTUAL") {

        var desconto =
              (parseFloat(this.element.value_subtotal_product) *
                parseFloat(this.valueDescont))/ 
              100;
  
            var DescontoPriceValueSales =    (parseFloat(this.element.value_sale) *
                parseFloat(this.valueDescont))/ 
              100;
            this.element.value_subtotal_product = parseFloat(this.element.value_subtotal_product).toFixed(2) - desconto.toFixed(2);
            this.element.value_sale  = this.element.value_sale -  DescontoPriceValueSales.toFixed(2)
            this.element.value_sale = this.element.value_sale.toFixed(2)
            this.element.value_descont_product += desconto;
            this.element.valueUnityBusinessProduct = this.element.value_sale
            this.recalculetributeEditQuantidadeItem(this.element)
            this.$store.dispatch(UPDATE_CART, this.element);
            this.dialog_descont = !this.dialog_descont;
            this.valueDescont = Number();

      } else if(this.type_descont == "DINHEIRO") {

        let convertionPercentualValue = (this.valueDescont / this.element.value_subtotal_product)
              var desconto =
                (parseFloat(this.element.value_subtotal_product) *
                  parseFloat(convertionPercentualValue))

              var DescontoPriceValueSales =    (parseFloat(this.element.value_sale) * parseFloat(convertionPercentualValue))
              this.element.value_subtotal_product = parseFloat(this.element.value_subtotal_product).toFixed(2) - desconto.toFixed(2);
              this.element.value_sale  = this.element.value_sale -  DescontoPriceValueSales.toFixed(2)
              this.element.value_sale = this.element.value_sale.toFixed(2)
              this.element.value_descont_product += desconto;
              this.element.valueUnityBusinessProduct = this.element.value_sale
              this.recalculetributeEditQuantidadeItem(this.element)
              this.$store.dispatch(UPDATE_CART, this.element);
              this.dialog_descont = !this.dialog_descont;
              this.valueDescont = Number();

      }
    },
    confirm_descont_item() {
      let productPrice = this.element.product.sale_price * this.element.amount
      let maxDescountValue = (productPrice / 100) * this["auth/getUser"].user.cashier_operation.limit_descont_percentual
      let maxDescountPercentualValue = Number()
      if(this.element.value_descont_product != 0) {
        maxDescountPercentualValue = (this.element.value_descont_product * 100) / productPrice 
      }
      switch (this.type_descont) {
        case "PERCENTUAL":
          if(this.valueDescont <= (this["auth/getUser"].user.cashier_operation.limit_descont_percentual - maxDescountPercentualValue)) {
            // if(this.valueDescont <= 50) {
              this.giveDiscount()
            } else {
            this.totalDescount = parseFloat(this.valueDescont) + maxDescountPercentualValue
            this.permissionDiscountDialog = true
          }

          break;
          case "DINHEIRO":
            if((parseFloat(this.valueDescont) + parseFloat(this.element.value_descont_product)) <= maxDescountValue) {
              // if(this.valueDescont <= 20) {
              this.giveDiscount()
            } else {
              this.totalDescount = parseFloat(this.valueDescont) + parseFloat(this.element.value_descont_product)
              this.totalDescount = (this.totalDescount * 100) / productPrice
              this.totalDescount = this.totalDescount.toFixed(2)
              this.permissionDiscountDialog = true
            }
          break;
      }

       this.calculate(this.$store.getters.getCart);


        // case "DINHEIRO":
        //   this.element.value_subtotal_product = parseFloat(this.element.value_subtotal_product).toFixed(2)  - parseFloat(this.valueDescont).toFixed(2);
        //   this.element.value_descont_product = this.valueDescont.toFixed(2);
        //   this.element.value_sale  = parseFloat(this.element.value_sale).toFixed(2) - parseFloat(this.valueDescont).toFixed(2);
        //   this.element.valueUnityBusinessProduct = this.element.value_sale
        //   this.recalculetributeEditQuantidadeItem(this.element)
        //   this.$store.dispatch(UPDATE_CART, this.element);
        //   this.dialog_descont = !this.dialog_descont;
        //   this.valueDescont = 0;
      
        //   break;

    },
    async confirmAlterQuantProduct() {
      this.element.amount = this.amount;
      this.element.value_subtotal_product = parseFloat(this.element.amount) * parseFloat(this.element.value_sale);
      this.recalculetributeEditQuantidadeItem(this.element);
      await this.$store.dispatch(UPDATE_CART, this.element);
      this.dialog = !this.dialog;
      this.amount = 0;
      this.calculate(this.$store.getters.getCart);
    },

    confirm_delete() {
      this.$store.dispatch(DESTROY_CART, this.getCart.indexOf(this.element));
      this.dialog_delete = !this.dialog_delete;
      this.calculate(this.$store.getters.getCart);
    },
    clearCart() {
      this.$store.dispatch(CLEAN_CART);
      this.dialog_clear = false;
      this.calculate(this.$store.getters.getCart);
    }
  },

  watch: {
    getCart: function() {
      this.calculate(this.$store.getters.getCart);
    },
    getEnterprises: function (val) {
      this.enterprise_id = val.data[0].id;
      this.getEnterprise = val.data[0]
    },
    items: function() {
      if (this.items.length > 0) {
        this.valid = false;
      } else {
        this.valid = true;
        this.showLoyaltyPanel = false;
        this.pointsToUse = 0;
        this.loyaltyDiscount = 0;
      }
    },
    getDiscountPermission: function(val) {
      if(val == false) {
        this.permissionDiscountDialog = false
      } else if(val == true) {
        this.permissionDiscountDialog = false
        this.giveDiscount()
      }
      this.$store.dispatch( SET_DISCOUNT_PERMISSION )
    },
    dialog_finish: function(newVal) {
      if (!newVal) {
        const pointsUsedInSale = this.component.loyaltyPointsUsedInSale || 0;
        if (pointsUsedInSale > 0 &&
            this.component.clientNfceObject &&
            this.component.clientNfceObject.loyalties &&
            this.component.clientNfceObject.loyalties.length > 0) {
          const currentPoints = this.component.clientNfceObject.loyalties[0].current_points;
          this.$set(this.component.clientNfceObject.loyalties[0], 'current_points', currentPoints - pointsUsedInSale);
          this.component.loyaltyPointsUsedInSale = 0;
        }

        this.pointsToUse = 0;
        this.loyaltyDiscount = 0;
        this.showLoyaltyPanel = false;
      }
    }
  },
  computed: {
    ...mapGetters(["getCart","getEnterprises", "auth/getUser", "getDiscountPermission", "getLoyaltyLedger", "isLoyaltyLoading"]),
    
    hasLoyaltyPoints() {
      const clientData = this.component.clientNfceObject;
      return clientData && clientData.loyalties && clientData.loyalties.length > 0 && clientData.loyalties[0].current_points > 0;
    },
    
    clientLoyaltyPoints() {
      const clientData = this.component.clientNfceObject;
      if (clientData && clientData.loyalties && clientData.loyalties.length > 0) {
        return clientData.loyalties[0].current_points;
      }
      return 0;
    },

    displayLoyaltyPoints() {
      const pointsUsed = parseInt(this.pointsToUse) || 0;
      return Math.max(0, this.clientLoyaltyPoints - pointsUsed);
    },

    totalWithLoyaltyDiscount() {
      return Math.max(0, this.total - this.loyaltyDiscount);
    },

    loyaltyLedgerData() {
      return this.getLoyaltyLedger && this.getLoyaltyLedger.data ? this.getLoyaltyLedger.data : [];
    }
  },
  mounted() {
    this.calculate(this.$store.getters.getCart);
  },
  async created() {
    this.user = { ...this.$store.state.auth.user.user };
    document.addEventListener("keyup", this.onKey);
    document.addEventListener("click", this.handleClickOutside);
    if (!this.getEnterprises?.data?.length) {
      await this.GetEnterprise();
    }
    await this.loadLoyaltySettings();
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.onKey);
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>
<style>
  .footerTable{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 15px;
  }
  .payment{
    font-size: clamp(14px, 2.5vw, 20px);
    font-weight: bold;
    text-align: left;
  }
  .infSeller{
    font-size: clamp(13px, 2.5vw, 20px);
    font-weight: bold;
  }
  .infSeller .operator{
    color: #304c64;
  }
  .infSeller .Name{
    color: grey;
  }
  .infSeller .pdvDescription{
    color: #304c64;
  }
  .infSeller .pdvId{
    color: grey;
  }
  .loyalty-points{
    color: #FFA726 !important;
    font-weight: bold;
  }
  
  .loyalty-popup {
    position: fixed;
    bottom: 120px;
    right: 200px;
    z-index: 5;
    width: 280px;
  }
  
  .loyalty-popup-content {
    background: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    position: relative;
  }
  
  .loyalty-popup-content::after {
    content: '';
    position: absolute;
    bottom: -8px;
    right: 50px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #f5f5f5;
  }
  
  .loyalty-popup-header {
    text-align: center;
    margin-bottom: 8px;
  }
  
  .loyalty-popup-title {
    color: #333;
    font-weight: bold;
    font-size: 14px;
  }
  
  .loyalty-popup-controls {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  
  .loyalty-input {
    flex: 1;
  }
  
  .loyalty-popup-discount {
    background: #fff;
    color: #dc3545;
    font-weight: bold;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 14px;
    min-width: 70px;
    text-align: center;
  }
  .payment-section {
    margin-bottom: 12px;
  }
  .discount-details {
    margin-top: 4px;
  }
  .discount-breakdown {
    color: #666;
    font-style: italic;
  }
  .info-section {
    margin-bottom: 8px;
  }

  .info-row {
    display: flex;
    margin-bottom: 4px;
    align-items: center;
  }

  .info-label {
    font-size: 16px;
    font-weight: bold;
    color: #304c64;
    min-width: 80px;
    margin-right: 8px;
  }

  .info-value {
    font-size: 16px;
    font-weight: bold;
    color: grey;
    word-break: break-word;
    flex: 1;
  }
  .paymentTotal{
    color: #304c64;
  }
.numberTotal{
  color: grey;
}

.card-actions-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px;
  width: 100%;
}

.footerTable {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 15px;
}

.actions-buttons {
  display: flex;
  gap: 8px;
}

.mobile-cart-list {
  max-height: 35vh;
  overflow-y: auto;
  padding: 4px 8px;
}

.mobile-cart-empty {
  text-align: center;
  padding: 16px;
  color: grey;
}

.mobile-cart-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 4px;
  border-bottom: 1px solid #e0e0e0;
  min-height: unset;
}

.mobile-cart-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.mobile-cart-desc {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-cart-detail {
  font-size: 12px;
  color: #555;
  margin-top: 2px;
}

.mobile-cart-actions {
  display: flex;
  gap: 8px;
  margin-left: 8px;
  flex-shrink: 0;
}

@media (max-width: 600px) {
  .card-actions-container {
    flex-direction: column;
    padding: 8px;
  }

  .mobile-hidden {
    display: none !important;
  }

  .footerTable {
    margin: 0;
    width: 100%;
    margin-bottom: 16px;
  }

  .actions-buttons {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 8px;
  }

  .action-btn {
    display: flex !important;
    width: 100% !important;
    height: 48px !important;
    margin: 4px 0 !important;
    justify-content: center !important;
  }

  .v-btn {
    display: flex !important;
    width: 100% !important;
  }

  .payment {
    font-size: 14px;
  }

  .infSeller {
    font-size: 13px;
  }

  .info-row {
    margin-bottom: 2px;
  }

  .info-label {
    font-size: 14px;
    min-width: 70px;
  }

  .info-value {
    font-size: 14px;
  }
  
  .loyalty-panel {
    margin: 0 8px 8px 8px;
  }
  
  .loyalty-panel-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .loyalty-panel-title {
    font-size: 14px;
  }
  
  .loyalty-panel-points {
    font-size: 13px;
  }
  
  .discount-value {
    font-size: 16px;
    padding: 6px;
  }

  .loyalty-popup {
    position: fixed;
    bottom: 100px;
    right: 10px;
    left: 10px;
    width: auto;
  }
}

/* Estilos para o extrato de fidelidade */
.loyalty-popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>